export default "__VITE_ASSET__BJPhZo9m__"